export class Checkup {
  public election: string;
  public apiVersion: string;
  public auditOwner: string;
  public checkupType: string;
  public electionHash: string;
  public questionsHash: string;
  public votedHash: string;
  public tallyHash: string;
  public consistency: string;
  public time: string;
  public votersHash: string;
  public integrity: boolean;
  public resultHash: string;
  public logsHash: string;
}

export class AuditsResponse {
  public audits: Array<Checkup>;
  public checkupData: Array<boolean>;
}

export class ElectionEventLine {
  public electionId: string;
  public time: string;
  public type: string;
  public userEmail: string;
  public userId: string;
  public changeVoterName: string;
  public changeVoterOldEmail: string;
  public changeVoterNewEmail: string;
  public target: string;
}

export class CheckupComparison {
  public lineName: string;
  public time: string;
  public currentHash: string;
  public initialHash: string;
  public hashComparison: string;

  constructor(lineName: string, time: string, currentHash: string, initialHash: string, integrity: boolean) {
    this.lineName = lineName;
    this.time = new Date(time).toLocaleString() ;
    this.initialHash = initialHash != null && initialHash.length > 10 ? initialHash.substr(0, 10) : initialHash;
    this.currentHash = currentHash != null && currentHash.length > 10 ? currentHash.substr(0, 10) : currentHash;
    this.hashComparison = integrity ? 'Intègre' : 'Non intègre';
  }
}
